import * as React from 'react'
import { BodyWithMenu } from '../../components/organisms/Menu'
import { createEnDaContent, translateContent } from '../../globals/Translations';

export const ErrorPage: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <BodyWithMenu>
      <div style={{textAlign: 'center'}}>
        <h1>{translateContent(createEnDaContent("Error","Fejl"))}</h1>
        <code>{message}</code>
      </div>
    </BodyWithMenu>
  )
};
